import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  elements: [],
};

export const textAnnotationsSlice = createSlice({
  name: "textAnnotations",
  initialState,
  reducers: {
    replaceTextAnnotations: (state, { payload }) => {
      return {
        ...state,
        elements: payload,
      };
    },
    createTextAnnotation: (state, { payload }) => {
      return {
        ...state,
        elements: [...state.elements, payload],
      };
    },
    // trigger by the end of that save
    // used to keep the edited label in the text state
    updateTextAnnotation: (state, { payload }) => {
      const index = state.elements.findIndex((el) => el.id === payload.id);
      if (index < 0) {
        return { ...state, elements: [...state.elements, payload] };
      }
      const elements = [...state.elements];
      elements[index] = payload;
      return { ...state, elements };
    },
    // trigger by the delete confirmation on a label selection
    // used to remove those labels from the map
    deleteTextAnnotations: (state, { payload: { ids } }) => {
      return {
        ...state,
        elements: state.elements.filter((el) => !ids.includes(el.id)),
      };
    },
  },
});

export const selectTextAnnotations = (state) => state.textAnnotations.elements;

export const {
  replaceTextAnnotations,
  createTextAnnotation,
  updateTextAnnotation,
  deleteTextAnnotations,
} = textAnnotationsSlice.actions;

export default textAnnotationsSlice.reducer;
